function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircleFilled, HelpCircle } from '@ori-ui/icons';
import { Box, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField, Tooltip, styled } from '@ori-ui/mui';
import { useGetTenantCountries } from '@ori/static-api-client-react';
import useTestId from '@ori/testid-generator';
import { useEffect, useState } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { Controller, useFormContext } from 'react-hook-form';
import { Localization } from '../../Localization';
import { defaultTranslations } from '../../constants/defaultTranslations';
import { useConfiguration } from '../../contexts';
import { TranslationKey } from '../../models';
import { isValidPhoneNumber } from '../../utils/isValidPhoneNumber';
import { AdornmentIcon } from '../AdornmentIcon';
var BoxWrapper = styled(Box)(function() {
    return {
        position: 'relative',
        display: 'flex',
        width: '100%'
    };
});
var BoxStyled = styled(Box)(function() {
    return {
        maxWidth: '500px',
        width: '100%',
        display: 'flex',
        alignItems: 'end'
    };
});
var InputLabelStyled = styled(InputLabel)(function() {
    return {
        fontSize: '14px',
        '&.MuiFormLabel-root': {
            transform: 'translate(0, -1px) scale(0.86) '
        }
    };
});
var FlagWrapper = styled('div')(function() {
    return {
        display: 'flex',
        alignItems: 'center'
    };
});
var StyledHelpCircle = styled(HelpCircle)(function(param) {
    var theme = param.theme;
    return {
        fontSize: '24px',
        color: theme.palette.grey[300]
    };
});
var MenuItemStyled = styled(MenuItem)(function(param) {
    var theme = param.theme;
    return {
        '&.MuiMenuItem-root': {
            '&.Mui-selected::after': {
                content: 'none'
            },
            svg: {
                fill: theme.palette.success.main
            }
        }
    };
});
var getCountryByCountryCode = function(countries, countryCode) {
    var _countries_find;
    return countries === null || countries === void 0 ? void 0 : (_countries_find = countries.find(function(country) {
        return country.countryCode === countryCode;
    })) === null || _countries_find === void 0 ? void 0 : _countries_find.name;
};
export var PhoneFieldByConfig = function(props) {
    var _availableOptions_find;
    var name = props.name, label = props.label, inputMode = props.inputMode, value = props.value, tooltipText = props.tooltipText, tooltipWithPrefix = props.tooltipWithPrefix;
    var _useTestId = useTestId(), getTestIdProps = _useTestId.getTestIdProps, getTestId = _useTestId.getTestId;
    var _useFormContext = useFormContext(), watch = _useFormContext.watch, setValue = _useFormContext.setValue;
    var _useConfiguration = useConfiguration(), allowedPhoneFormats = _useConfiguration.allowedPhoneFormats, tenant = _useConfiguration.tenant;
    var _useState = _sliced_to_array(useState(), 2), phonePrefix = _useState[0], setPhonePrefix = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), phoneWithoutPrefix = _useState1[0], setPhoneWithoutPrefix = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), disabledPrefix = _useState2[0], setDisabledPrefix = _useState2[1];
    var _useGetTenantCountries = useGetTenantCountries(tenant), countries = _useGetTenantCountries.data;
    var availableOptions = allowedPhoneFormats.map(function(opt) {
        return {
            countryCode: opt.countryCode === 'UK' ? 'GB' : opt.countryCode,
            label: opt.internationalPrefix,
            value: opt.internationalPrefix
        };
    });
    var includesPrefix = availableOptions === null || availableOptions === void 0 ? void 0 : (_availableOptions_find = availableOptions.find(function(x) {
        return value === null || value === void 0 ? void 0 : value.includes(x.value);
    })) === null || _availableOptions_find === void 0 ? void 0 : _availableOptions_find.value;
    var isAnyPhoneFormats = Boolean((availableOptions === null || availableOptions === void 0 ? void 0 : availableOptions.length) && availableOptions.length > 0);
    var showPrefix = Boolean(allowedPhoneFormats.length && allowedPhoneFormats.length > 0);
    var initialPrefix = availableOptions === null || availableOptions === void 0 ? void 0 : availableOptions.find(function(opt) {
        return opt.value;
    });
    var onlyOnePrefix = (availableOptions === null || availableOptions === void 0 ? void 0 : availableOptions.length) === 1;
    var phoneValue = watch('LoginPhone');
    useEffect(function() {
        if (availableOptions && onlyOnePrefix) {
            setDisabledPrefix(true);
        }
    }, [
        availableOptions,
        onlyOnePrefix
    ]);
    useEffect(function() {
        if (!phonePrefix && initialPrefix) {
            setPhonePrefix(includesPrefix !== null && includesPrefix !== void 0 ? includesPrefix : initialPrefix.value);
        } else if (availableOptions && !phonePrefix) {
            var _availableOptions_;
            setPhonePrefix((_availableOptions_ = availableOptions[0]) === null || _availableOptions_ === void 0 ? void 0 : _availableOptions_.value);
        } else {
            setPhonePrefix(phonePrefix);
        }
    }, [
        initialPrefix,
        phonePrefix,
        availableOptions,
        includesPrefix
    ]);
    useEffect(function() {
        if (phoneValue && phonePrefix) {
            setPhoneWithoutPrefix(phoneValue.replace(phonePrefix, ''));
        }
    }, [
        phonePrefix,
        phoneValue
    ]);
    var renderSelectOption = function(item, index) {
        var isSelected = phonePrefix === item.value;
        return /*#__PURE__*/ _jsxs(MenuItemStyled, _object_spread_props(_object_spread({
            value: item.value
        }, getTestIdProps('select-field-option')), {
            children: [
                /*#__PURE__*/ _jsxs(Box, {
                    display: "flex",
                    alignItems: "center",
                    children: [
                        item.countryCode ? /*#__PURE__*/ _jsx(ReactCountryFlag, {
                            svg: true,
                            countryCode: item.countryCode,
                            style: {
                                width: '18px',
                                height: '18px',
                                objectFit: 'cover',
                                borderRadius: '50%',
                                marginRight: '8px'
                            }
                        }) : null,
                        getCountryByCountryCode(countries === null || countries === void 0 ? void 0 : countries.collection, item.countryCode),
                        " (",
                        item.label,
                        ")"
                    ]
                }),
                isSelected ? /*#__PURE__*/ _jsx(CheckCircleFilled, {}) : null
            ]
        }), index);
    };
    var handlePrefixChange = function(event) {
        var value = event.target.value;
        setPhonePrefix(value);
        var currentValue = phoneWithoutPrefix && (value === null || value === void 0 ? void 0 : value.concat(phoneWithoutPrefix));
        if (phoneValue) {
            setValue(name, currentValue === null || currentValue === void 0 ? void 0 : currentValue.trim(), {
                shouldValidate: true,
                shouldDirty: true,
                shouldTouch: true
            });
        }
    };
    var getCorrectValue = function(fieldValue) {
        if (showPrefix) {
            return fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.replace(phonePrefix !== null && phonePrefix !== void 0 ? phonePrefix : '', '');
        }
        return fieldValue;
    };
    var handleChangeAllowOnlyNumber = function(available, value) {
        var correctValue = value;
        if (available && correctValue.startsWith('0') && showPrefix) {
            correctValue = correctValue.slice(1).replaceAll(/\D/g, '');
        }
        if (available) {
            correctValue = isValidPhoneNumber(correctValue);
        }
        var currentValue = showPrefix ? correctValue && (phonePrefix === null || phonePrefix === void 0 ? void 0 : phonePrefix.concat(correctValue)) : isValidPhoneNumber(correctValue);
        return currentValue === null || currentValue === void 0 ? void 0 : currentValue.trim();
    };
    var renderHelpTooltip = function() {
        return /*#__PURE__*/ _jsx(Tooltip, {
            title: isAnyPhoneFormats ? tooltipWithPrefix : tooltipText,
            enterTouchDelay: 0,
            leaveTouchDelay: 5000,
            children: /*#__PURE__*/ _jsx(StyledHelpCircle, {})
        });
    };
    return /*#__PURE__*/ _jsx(Grid, {
        size: {
            xs: 12
        },
        children: /*#__PURE__*/ _jsxs(BoxWrapper, {
            children: [
                showPrefix ? /*#__PURE__*/ _jsx(Box, {
                    maxWidth: 90,
                    width: 100,
                    marginRight: 4,
                    children: /*#__PURE__*/ _jsxs(FormControl, {
                        fullWidth: true,
                        sx: {
                            position: 'initial'
                        },
                        children: [
                            /*#__PURE__*/ _jsx(InputLabelStyled, {
                                id: "".concat(name, "-prefix-label"),
                                children: label
                            }),
                            /*#__PURE__*/ _jsx(Select, {
                                displayEmpty: true,
                                disabled: disabledPrefix,
                                labelId: "".concat(name, "-prefix-label"),
                                variant: "standard",
                                sx: {
                                    minWidth: '90px',
                                    fontSize: '14px',
                                    svg: {
                                        fontSize: 25
                                    },
                                    '&.MuiInputBase-root.MuiInput-root': {
                                        marginTop: '20px'
                                    },
                                    '& .MuiInputBase-input.Mui-disabled': {
                                        WebkitTextFillColor: '#333'
                                    }
                                },
                                renderValue: function(selected) {
                                    if (!(selected === null || selected === void 0 ? void 0 : selected.length)) {
                                        return undefined;
                                    }
                                    var foundCode = availableOptions === null || availableOptions === void 0 ? void 0 : availableOptions.find(function(opt) {
                                        return opt.value === selected;
                                    });
                                    if (foundCode === null || foundCode === void 0 ? void 0 : foundCode.countryCode) {
                                        return /*#__PURE__*/ _jsxs(FlagWrapper, {
                                            children: [
                                                /*#__PURE__*/ _jsx(ReactCountryFlag, {
                                                    svg: true,
                                                    countryCode: foundCode.countryCode,
                                                    style: {
                                                        width: '18px',
                                                        height: '18px',
                                                        objectFit: 'cover',
                                                        borderRadius: '50%',
                                                        marginRight: '8px'
                                                    }
                                                }),
                                                "(",
                                                selected,
                                                ")"
                                            ]
                                        });
                                    }
                                    return selected;
                                },
                                inputProps: {
                                    'data-testid': getTestId("".concat(name, "-phone-field"))
                                },
                                value: phonePrefix,
                                defaultValue: phonePrefix,
                                onChange: function(e) {
                                    return handlePrefixChange(e);
                                },
                                children: availableOptions === null || availableOptions === void 0 ? void 0 : availableOptions.map(renderSelectOption)
                            })
                        ]
                    }, phonePrefix)
                }) : null,
                /*#__PURE__*/ _jsx(BoxStyled, {
                    children: /*#__PURE__*/ _jsx(Controller, {
                        name: name,
                        defaultValue: value !== null && value !== void 0 ? value : '',
                        render: function(_param) {
                            var _param_field = _param.field, ref = _param_field.ref, onChange = _param_field.onChange, fieldState = _param.fieldState, field = _object_without_properties(_param.field, [
                                "ref",
                                "onChange"
                            ]);
                            return /*#__PURE__*/ _jsxs(FormControl, {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                                        fullWidth: true,
                                        label: isAnyPhoneFormats ? null : label,
                                        type: inputMode !== null && inputMode !== void 0 ? inputMode : 'text',
                                        variant: "standard",
                                        error: !!fieldState.error,
                                        InputProps: {
                                            endAdornment: fieldState.error ? /*#__PURE__*/ _jsx(AdornmentIcon, {
                                                fieldState: fieldState,
                                                text: /*#__PURE__*/ _jsx(Localization, {
                                                    defaultMessage: defaultTranslations.invalidLoginPhone,
                                                    id: TranslationKey.invalidLoginPhone
                                                })
                                            }) : renderHelpTooltip(),
                                            autoComplete: 'off',
                                            inputProps: {
                                                inputMode: 'tel',
                                                'data-testid': getTestId("".concat(name, "-phone-field")),
                                                autoCapitalize: 'off',
                                                sx: {
                                                    '&::placeholder': {
                                                        textTransform: 'initial'
                                                    },
                                                    fontSize: '14px'
                                                }
                                            }
                                        }
                                    }, field), {
                                        value: getCorrectValue(field.value),
                                        inputRef: ref,
                                        onChange: function(e) {
                                            return onChange(handleChangeAllowOnlyNumber(isAnyPhoneFormats, e.target.value));
                                        }
                                    })),
                                    fieldState.error && !isAnyPhoneFormats ? /*#__PURE__*/ _jsx(FormHelperText, {
                                        error: true,
                                        children: fieldState.error.message
                                    }) : null
                                ]
                            });
                        }
                    })
                })
            ]
        })
    });
};
